/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import {
  //dateOptionList as _dateOptionList,
  dateToViewFormat,
  dateOptionListEx,
} from "../../utils/date";

import Button from "../Button";
import { hasParents } from "../../utils/element";

import SVG from "react-inlinesvg";
import calendarIcon from "../../assets/images/icon/calendar.svg";
import DatePicker from "../DatePicker";
import { isArray, isEmpty } from "lodash";


const Display = (props) => {
  const { date } = props;
  return (
    <>
      <span className="inline-block">
        {isEmpty(date) && "전체기간"}
        {!isEmpty(date) && `${dateToViewFormat(date[0])}`}
      </span>
      <span className="inline-block period_bar">-</span>
      <span className="inline-block">
        {!isEmpty(date) && date[1] && `${dateToViewFormat(date[1])}`}
      </span>
      <SVG src={calendarIcon} className="icon float-right" />
    </>
  );
};

const DateButton = ({ label, onClick, datas }) => {
  return (
    <Button
      color={"text"}
      size={"sm"}
      style={{
        width: "100%",
      }}
      onClick={onClick}
    >
      {label}
    </Button>
  );
};

const CustomDatePicker = (props) => {
  const {
    field,
    defaultValue,
    onChange,
    dateOptionList = dateOptionListEx(),
  } = props;
  const [isCustomDateOpen, setIsCustomDateOpen] = useState(false);
  const [date, setDate] = useState([]);

  useEffect(() => {
    defaultValue && setDate(defaultValue);
  }, [defaultValue]);



  const closeCustomDate = useCallback((e) => {
    e.preventDefault();
    if (!hasParents(e.target, "custom-date-picker")) {
      setIsCustomDateOpen(false);
    }
  }, []);

  useEffect(() => {
    if (isCustomDateOpen) {
      window.addEventListener("click", closeCustomDate);
    } else {
      window.removeEventListener("click", closeCustomDate);
    }
  }, [isCustomDateOpen]);

  const _setDate = (dates) => {
    const _dates = isArray(dates) ? { [field.key]: dates } : dates;
    setDate(_dates[field.key]);
    if (onChange) onChange(_dates);

    if (_dates[field.key].length === 2) setIsCustomDateOpen(false);
  };

  return (
    <div className="custom-date-picker">
      <div
        className="custom-date-picker-display"
        onClick={() => setIsCustomDateOpen(!isCustomDateOpen)}
      >
        <Display date={date} />
      </div>
      <div
        className={`custom-date-picker-wrap ${isCustomDateOpen ? "" : "display-none"
          }`}
      >
        <div className="custom-date-picker-box">
          <DatePicker
            field={field}
            defaultValue={date}
            options={{
              mode: "range",
              dateFormat: "Y-m-d",
            }}
            onChange={_setDate}
          />
        </div>
        <div className="custom-date-list">
          {/** 
          {dateOptionList.map((button, idx) => (
            <DateButton
              {...button}
              key={idx}
              onClick={() => {
                _setDate([button.datas.from, button.datas.to])
                setIsCustomDateOpen(false)
              }}
            />
          ))}
          */}

          <table className="w-full">
            <tbody>
              <tr><td width="25%"></td><td width="25%"></td><td width="25%"></td><td width="25%"></td></tr>
              {dateOptionList.map((range, index) => (
                <tr key={index}>
                  {range.map((button, idx) => (

                    <td colSpan={button.colSpan} key={idx + 100 * (index)}>
                      <DateButton
                        label={button.label}
                        key={idx + 100 * (index)}
                        onClick={() => {
                          _setDate([button.from, button.to]);
                          setIsCustomDateOpen(false);
                        }}
                      />
                    </td>
                  ))}
                </tr>
              ))
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default CustomDatePicker;
